// The design's 93 Lucide icons (references/design/icons.txt), keyed by their Lucide names.
// lucide-react@1.58 draws 91 of them exactly as the design's <lu-icon> set does (checked by
// rasterising both in Chrome). Two differ, so they carry the design's geometry (Lucide, ISC):
// `instagram` (brand icons were removed in lucide v1) and `file-code-2` (redrawn in v1).
import {
  ArrowDown, ArrowRight, ArrowUp, ArrowUpRight, BadgeCheck, Bell, BookmarkPlus, Bot, Boxes, Building2,
  CalendarClock, Check, ChevronDown, ChevronRight, CircleCheck, CircleDashed, CircleHelp, CloudUpload, Copy,
  CreditCard, createLucideIcon, Eraser, ExternalLink, File, FileSpreadsheet, FileText, FlaskConical, Globe,
  GlobeLock, GripVertical, Hammer, HardDrive, History, Image, ImagePlus, ImageUp, Info, Layers, LayoutDashboard,
  LayoutGrid, LayoutPanelLeft, LibraryBig, Link, ListChecks, Loader, Lock, LogOut, MapPin, Maximize2,
  MessageSquareQuote, Minimize2, MousePointerClick, Package, Palette, PanelBottom, PanelTop, Pencil, Percent,
  PlugZap, Plus, Redo2, RefreshCw, Rocket, RotateCcw, ScanSearch, ScrollText, Search, Send, Settings2, Shapes,
  Shield, ShieldAlert, ShieldCheck, ShoppingBag, ShoppingCart, SlidersHorizontal, Smartphone, Sparkles,
  SquareDashed, SquarePlus, Star, Trash2, TriangleAlert, Truck, Undo2, Upload, Users, WalletCards, WandSparkles,
  Wrench, X, Zap, type LucideIcon,
} from 'lucide-react';

const Instagram = createLucideIcon('instagram', [
  ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '5', ry: '5', key: 'r' }],
  ['path', { d: 'M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01', key: 'p' }],
]);

const FileCode2 = createLucideIcon('file-code-2', [
  ['path', { d: 'M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4', key: 'a' }],
  ['path', { d: 'M14 2v4a2 2 0 0 0 2 2h4M5 12l-3 3l3 3m4 0l3-3l-3-3', key: 'b' }],
]);

export const ICONS = {
  'arrow-down': ArrowDown,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-up-right': ArrowUpRight,
  'badge-check': BadgeCheck,
  bell: Bell,
  'bookmark-plus': BookmarkPlus,
  bot: Bot,
  boxes: Boxes,
  'building-2': Building2,
  'calendar-clock': CalendarClock,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'circle-check': CircleCheck,
  'circle-dashed': CircleDashed,
  'circle-help': CircleHelp,
  'cloud-upload': CloudUpload,
  copy: Copy,
  'credit-card': CreditCard,
  eraser: Eraser,
  'external-link': ExternalLink,
  file: File,
  'file-code-2': FileCode2,
  'file-spreadsheet': FileSpreadsheet,
  'file-text': FileText,
  'flask-conical': FlaskConical,
  globe: Globe,
  'globe-lock': GlobeLock,
  'grip-vertical': GripVertical,
  hammer: Hammer,
  'hard-drive': HardDrive,
  history: History,
  image: Image,
  'image-plus': ImagePlus,
  'image-up': ImageUp,
  info: Info,
  instagram: Instagram,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  'layout-grid': LayoutGrid,
  'layout-panel-left': LayoutPanelLeft,
  'library-big': LibraryBig,
  link: Link,
  'list-checks': ListChecks,
  loader: Loader,
  lock: Lock,
  'log-out': LogOut,
  'map-pin': MapPin,
  'maximize-2': Maximize2,
  'message-square-quote': MessageSquareQuote,
  'minimize-2': Minimize2,
  'mouse-pointer-click': MousePointerClick,
  package: Package,
  palette: Palette,
  'panel-bottom': PanelBottom,
  'panel-top': PanelTop,
  pencil: Pencil,
  percent: Percent,
  'plug-zap': PlugZap,
  plus: Plus,
  'redo-2': Redo2,
  'refresh-cw': RefreshCw,
  rocket: Rocket,
  'rotate-ccw': RotateCcw,
  'scan-search': ScanSearch,
  'scroll-text': ScrollText,
  search: Search,
  send: Send,
  'settings-2': Settings2,
  shapes: Shapes,
  shield: Shield,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  'sliders-horizontal': SlidersHorizontal,
  smartphone: Smartphone,
  sparkles: Sparkles,
  'square-dashed': SquareDashed,
  'square-plus': SquarePlus,
  star: Star,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  truck: Truck,
  'undo-2': Undo2,
  upload: Upload,
  users: Users,
  'wallet-cards': WalletCards,
  'wand-sparkles': WandSparkles,
  wrench: Wrench,
  x: X,
  zap: Zap,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;
